import { Base } from "@app/controllers/base";
import { renderStreamMessage } from "@hotwired/turbo"

// Connects to data-controller="store--booking-filter"
export default class extends Base {
  static targets = ["filterBtn", "search"]
  static values = {
    url: String,
    initialStatus: { type: String, default: "all" }
  }

  connect() {
    this.activeStatus = this.initialStatusValue
    this.debounceTimer = null
    this.updateStatusStyles()
  }

  setStatus(event) {
    const btn = event.currentTarget
    this.activeStatus = btn.dataset.status
    this.updateStatusStyles()
    this.submit()
  }

  onSearch() {
    this.submit()
  }

  updateStatusStyles() {
    this.filterBtnTargets.forEach(b => {
      const isActive = b.dataset.status === this.activeStatus
      b.className = isActive 
        ? "inline-flex items-center gap-1.5 rounded-full px-3.5 py-1.5 text-sm font-medium transition bg-navy text-white"
        : "inline-flex items-center gap-1.5 rounded-full px-3.5 py-1.5 text-sm font-medium transition bg-light text-muted-foreground hover:bg-surface"

      const badge = b.querySelector("span")
      if (badge) {
        badge.className = isActive
          ? "rounded-full px-1.5 text-[11px] bg-white/15 text-white"
          : "rounded-full px-1.5 text-[11px] bg-background text-foreground/60"
      }
    })
  }

  submit() {
    clearTimeout(this.debounceTimer)
    this.debounceTimer = setTimeout(() => this.fetchResults(), 350)
  }

  async fetchResults() {
    const url = new URL(this.urlValue, window.location.origin)
    const p = url.searchParams

    if (this.hasSearchTarget) p.set("search", this.searchTarget.value)
    p.set("status", this.activeStatus)

    const response = await fetch(url.toString(), {
      headers: { Accept: "text/vnd.turbo-stream.html" }
    })
    const html = await response.text()
    renderStreamMessage(html)
  }
}
